interface ISaveActionButtonProps {
    label: string
    onClick?: () => void
    disabled?: boolean
}

export const SaveActionButton = (props: ISaveActionButtonProps) => {
    const disabled = !!props.disabled
    const classes = `rounded-lg px-3 py-3 text-base w-fit flex flex-row items-center ${
        disabled 
            ? 'bg-mediaBackground opacity-50 cursor-not-allowed' 
            : 'bg-black text-white cursor-pointer'
    }`
    const handleClick = () => {
        if (disabled) return
        props.onClick?.()
    }
    return (
        <div
          role="button"
          aria-disabled={disabled}
          onClick={handleClick}
          className={classes}
        >
          <div className={'text-base'}>{props.label}</div>
        </div>
    )
}
